import axios from 'axios';
import {
  AXIOS_XHR_CONFIG,
  AXIOS_FORM_DATA_CONFIG,
  makeCancellableAxiosXhrConfig,
} from 'react/shared/utils/Axios';

export default {
  createSignup(signupParams) {
    return axios.post(
      RailsRoutes.api_v1_signups_card_account_signups_path({ format: 'json' }),
      signupParams,
      AXIOS_XHR_CONFIG,
    );
  },

  createEmailSignup(signupParams) {
    return axios.post(
      RailsRoutes.api_v2_signups_card_account_signups_path({ format: 'json' }),
      signupParams,
      AXIOS_XHR_CONFIG,
    );
  },

  completeSignup(cardAccountSignupId) {
    return axios.patch(
      RailsRoutes.complete_api_v1_signups_card_account_signup_path(cardAccountSignupId, {
        format: 'json',
      }),
      AXIOS_XHR_CONFIG,
    );
  },

  createSignupLog(cardAccountSignupId, logParams) {
    return axios.post(
      RailsRoutes.api_v1_signups_card_account_signup_logs_path(cardAccountSignupId, {
        format: 'json',
      }),
      {
        data: {
          type: 'CardAccountSignupLog',
          attributes: logParams,
        },
      },
      AXIOS_XHR_CONFIG,
    );
  },

  createAccount(organizationId, accountParams) {
    return axios.post(
      RailsRoutes.api_v1_create_account_path(organizationId, { format: 'json' }),
      accountParams,
      AXIOS_XHR_CONFIG,
    );
  },

  getAccount(accountId) {
    if (!accountId) {
      return Promise.resolve();
    }
    return axios.get(
      RailsRoutes.api_v1_account_path(accountId, { format: 'json' }),
      AXIOS_XHR_CONFIG,
    );
  },

  updateAccount(accountId, accountParams) {
    return axios.put(
      RailsRoutes.api_v1_account_path(accountId, { format: 'json' }),
      accountParams,
      AXIOS_XHR_CONFIG,
    );
  },

  createUser(userParams) {
    return axios.post(
      RailsRoutes.api_v1_users_path({ format: 'json' }),
      userParams,
      AXIOS_XHR_CONFIG,
    );
  },

  getUser(userId) {
    return axios.get(RailsRoutes.api_v1_user_path(userId, { format: 'json' }), AXIOS_XHR_CONFIG);
  },

  identitySignup(userId, idvParams) {
    return axios.post(
      RailsRoutes.identity_signup_api_v1_user_path(userId, { format: 'json' }),
      idvParams,
      AXIOS_XHR_CONFIG,
    );
  },

  updateUser(userId, userParams) {
    return axios.patch(
      RailsRoutes.api_v1_user_path(userId, { format: 'json' }),
      userParams,
      AXIOS_XHR_CONFIG,
    );
  },

  getCardProgramQuestions(orgId, cancelToken = null) {
    const config = cancelToken ? makeCancellableAxiosXhrConfig(cancelToken) : AXIOS_XHR_CONFIG;

    return axios.get(
      RailsRoutes.card_program_questions_api_v1_organization_path(orgId, { format: 'json' }),
      config,
    );
  },

  createCardAccountTrust(accountId, params) {
    return axios.post(
      RailsRoutes.api_v1_create_card_account_trust_path(accountId, { format: 'json' }),
      params,
      AXIOS_FORM_DATA_CONFIG,
    );
  },

  updateCardAccountTrust(cardAccountTrustId, params) {
    return axios.patch(
      RailsRoutes.api_v1_card_account_trust_path(cardAccountTrustId, { format: 'json' }),
      params,
      AXIOS_FORM_DATA_CONFIG,
    );
  },

  getCardAccountTrust(cardAccountTrustId) {
    if (!cardAccountTrustId) {
      return Promise.resolve();
    }

    return axios.get(
      RailsRoutes.api_v1_card_account_trust_path(cardAccountTrustId, { format: 'json' }),
      AXIOS_XHR_CONFIG,
    );
  },
};
